export const responseRedshiftAccountMapping = '';